import { PriceListContext } from './context';
import { useContext } from "react";

export const HideControlsByRateType = ({children, rates})=>{
    const { state } = useContext(PriceListContext);    
    return !(rates.some(r => r === state?.RateCategoryId)) && children
}